import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/retirement-withdrawal',
  component: () => import('../../routes/RetirementWithdrawal.svelte'),
  card: {
    id: 'retirement-withdrawal',
    title: 'Retirement Withdrawal',
    description: 'Model different retirement withdrawal strategies and see how long your portfolio will last. Compare fixed, percentage, floor, and dynamic strategies.',
    icon: 'payments',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/retirement-withdrawal',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Retirement Withdrawal Calculator – Model Your Retirement Income Strategy',
    description: 'Free retirement withdrawal calculator to model different strategies: fixed dollar, fixed percentage, floor & ceiling, and Guyton-Klinger. See how long your portfolio will last and optimize your retirement income.',
  },
};

export default meta;
